import { useEffect, useRef } from "react";
import InfoSignatureStep0Bloc from "../blocs/info-signature/InfoSignatureStep0Bloc";
import { isMobile, scroll2Top } from "../utils/utils";

export default function InfoSignatureStep0Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
      
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Signez vos documents précontractuels</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
            <InfoSignatureStep0Bloc/>
        </div>
      </div>
      
    )

}